export default __webpack_public_path__ + "static/media/DOM-JUNE2026.5ee13672.png";